<template>
  <div class="container">
    <pi-my-user-info
      :userType="userType"
      :userInfo="userInfo"
      :accountObj="accountObj"
      :configData="configData"
      :isLogin="isLogin"
    ></pi-my-user-info>
    <div class="container-flex my-content">
      <div class="month-dl-box">
        <div class="month-dl-name">本月充电量(度)</div>
        <div class="month-dl-value">
          {{ elecOfCurrMonth }}
        </div>
      </div>
      <pi-my-account-tabs
        :accountObj="accountObj"
        :configData="configData"
        ref="myAccountTabs"
      ></pi-my-account-tabs>
      <div class="out-login" @click="exitLogin">退出登录</div>
    </div>
  </div>
</template>

<script>
import {
  getUserBaseInfo,
  getAccountBaseInfo,
  getOprFeatureConfig,
  exitLogin,
} from "@/common/api";
import myUserInfo from "./components/pi-my-user-info/pi-my-user-info.vue";
import myAccountTabs from "./components/pi-my-account-tabs/pi-my-account-tabs.vue";
import initFn from "@/common/init";
export default {
  name: "my",
  components: {
    [myUserInfo.name]: myUserInfo,
    [myAccountTabs.name]: myAccountTabs,
  },
  data() {
    return {
      accountObj: {},
      userInfo: {},
      configData: {},
      isLogin: true,
      userType: 1, // 1 普通会员   2 普通会员+ 企业会员（有打折） 3 普通会员+ 企业支付  4 普通会员 + 企业管理员
    };
  },
  computed: {
    elecOfCurrMonth() {
      return this.accountObj.personalAccount &&
        this.accountObj.personalAccount.elecOfCurrMonth
        ? this.accountObj.personalAccount.elecOfCurrMonth
        : 0;
    },
  },
  mounted() {
    this.getOprFeatureConfig();
    this.getAccountBaseInfo();
    this.getUserBaseInfo();
  },
  destroyed() {},
  methods: {
    /**
     * 获取运营商系统功能配置信息
     */
    async getOprFeatureConfig() {
      let ret = await getOprFeatureConfig({}, { loading: false });
      if (ret.status === 0) {
        this.configData = ret.data[0] || {};
      }
    },
    /**
     * 获取账户信息
     */
    async getAccountBaseInfo() {
      let ret = await getAccountBaseInfo({});
      if (ret.status === 0) {
        let data = ret.data[0] || {};
        this.accountObj = data;
        if (data.vipTypes) {
          if (data.vipTypes.indexOf(2) != -1) {
            this.userType = 2;
          }
          if (data.vipTypes.indexOf(3) != -1) {
            this.userType = 3;
          }
        }
        if (data.entPayAdminAccount) {
          this.userType = 4;
        }
        let active = this.$common.get('my-tabs-active');
        if(active && this.userType != 1){
          this.$nextTick(()=>{
              this.$refs.myAccountTabs.accoutnTypeClick(active)
          })
          
        }
      }
    },
    /**
     * 获取用户信息
     */
    async getUserBaseInfo() {
      let ret = await getUserBaseInfo({}, { loading: false });
      if (ret.status === 0) {
        let data = ret.data[0] || {};
        this.userInfo = data;
      }
    },

    exitLogin() {
      this.$toast.clear();
      this.$dialog
        .confirm({
          message: "确定要退出登录吗",
          confirmButtonText: "确定",
          confirmButtonColor: "#14CC80",
          closeOnPopstate: true,
        })
        .then(() => {
          exitLogin(null, true)
            .then((data) => {
              if (data.status === this.$config.ajaxStatus) {
                this.$common.remove(
                  this.$config.localKeyLogin.homeShowListStatus
                );
                this.$common.remove(this.$config.localKeyLogin.phoneInfo);
                initFn.clearLocalData();
                this.$router.replace({
                  name: "login",
                  query: { oprPkId: this.$oprPkId, replace: true },
                });
              }
            })
            .catch((error) => {
              console.log(error);
              this.$toast("退出登录失败");
            });
        })
        .catch(() => {
          // on cancel
        });
    },
  },
};
</script>
<style lang="less" scoped>
.my-content {
  padding: 0.15rem 0.2rem 0.2rem 0.2rem;
}
.month-dl-box {
  display: flex;
  height: 0.7rem;
  line-height: 0.7rem;
  background: linear-gradient(44deg, #03f0b2 0%, #0eff9c 100%);
  box-shadow: 0px 0px 0.1rem 0px #efeff4;
  border-radius: 0.16rem 0.16rem 0px 0px;
  filter: blur(0px);
  padding: 0 0.2rem;
  color: #fff;
}
.month-dl-box .month-dl-name {
  flex: 1;
  font-size: 0.28rem;
}
.month-dl-box .month-dl-value {
  font-size: 0.4rem;
}
.out-login{
  margin: 0.4rem;
  text-align: center;
  color: #999;
}
</style>
